import { observer } from 'mobx-react-lite';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import * as React from 'react';

export interface FileProviderViewProps {
    icon: JSX.Element;
    name: string;
    onClick: () => void;
    ariaLabel: string;
    isSelected?: boolean;
}

const classNames = require('classnames');
const styles = require('./FileProviderView.scss');

const FileProviderView = observer(function FileProviderView(props: FileProviderViewProps) {
    const { name } = props;
    const filePickerViewStyles = classNames([
        styles.container,
        { [styles.providerSelected]: props.isSelected },
    ]);

    const ariaProps: AriaProperties = {
        role: AriaRoles.button,
        label: props.ariaLabel,
    };

    return (
        <div
            className={filePickerViewStyles}
            data-is-focusable={true}
            onClick={props.onClick}
            {...generateDomPropertiesForAria(ariaProps)}>
            <div className={styles.providerImage}>{props.icon}</div>

            {/* The container for the provider name */}
            <div className={styles.providerInformationContainer}>
                <div className={styles.providerName}>{name}</div>
            </div>
        </div>
    );
});
export default FileProviderView;
